import { DossierDetailType } from "../types";
import { compareDatesDescending, compareDatesAscending } from "../lib";

export function sortDescending(
    dossiers: any[],
    getCriteria: (d: DossierDetailType) => string | null
) {
    return dossiers.sort(
        (dBefore: DossierDetailType, dNext: DossierDetailType) =>
            compareDatesDescending(getCriteria(dBefore), getCriteria(dNext))
    );
}

export function sortAscending(
    dossiers: any[],
    getCriteria: (d: DossierDetailType) => string | null
) {
    return dossiers.sort(
        (dBefore: DossierDetailType, dNext: DossierDetailType) =>
            compareDatesAscending(getCriteria(dBefore), getCriteria(dNext))
    );
}
